import React from 'react';
import classes from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
const Footer = props => {
    return (
        <section className={`${classes['footer-area']} `}>
            <div className={classes['footer-area-bg']}>
                <div className="container text-center">
                    <div className="row ">
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div className={classes['footer-top']}>
                                <div className={`{classes["footer-logo"]} mt-5 mb-5`}>
                                    <img src="https://quomodosoft.com/html/dawat/demo/img/main_logo.png" alt="" />
                                </div>
                                <div className={`${classes["footer-address"]} text-white mb-5`}>
                                    <p>25 Road,Jadavpur University, Jadavpur</p>


                                    <p><a href="mailto:mehedidb@gmail.com">hello@dawat.com</a></p>
                                    <p><a href="callto:+8800000001111">+88 000 0000 1111</a></p>
                                </div>
                                <div className={`${classes.footerhandles} text-center`}>
                                    <ul>
                                        <li><a href="">
                                            <FontAwesomeIcon icon={faFacebook} /></a>
                                        </li>
                                        <li><a href="">
                                            <FontAwesomeIcon icon={faFacebook} /></a>
                                        </li>
                                        <li><a href="">
                                            <FontAwesomeIcon icon={faFacebook} /></a>
                                        </li>
                                        <li><a href="">
                                            <FontAwesomeIcon icon={faFacebook} /></a>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`row text-white ${classes['footer-menu-area']}`}>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                            <div className="footer-menu text-start" id={classes.centered}> 
                                <ul className="list-inline list-unstyled ">
                                    <li className='list-inline-item'><a href="" >Teams of use</a></li>
                                    <li className='list-inline-item'><a href="" >Privacy Policy</a></li>
                                    <li className='list-inline-item'><a href="" >SiteMap</a></li>
                                    <li className='list-inline-item'><a href="" >Contact</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12" >
                            <div className={`${classes["footer-copyright"]} text-end`} id={classes.centered}>
                                <p>© 2022 <a href="">My Restaurant</a> All Right Reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Footer;